/**
 * @param {jQuery} $ jQuery object.
 */
(function( $ ) {

	/**
	 * Selects
	 *
	 * @since 1.0.0
	 * @type {object}
	 */
	var self = Astoundify.Select = _.extend( {}, {
	}, Astoundify.Select || {} );

	/**
	 * Wrap
	 *
	 * @since 1.0.0
	 */
	self.wrap = function() {
		$( 'select' ).each(function() {
			self.create( $(this) );
		});
	};

	/**
	 * Create a select.
	 *
	 * @since 1.0.0
	 *
	 * @param string element
	 */
	self.create = function( element ) {
		var $el = $(element);

		if ( $el.hasClass( 'select2' ) ) {
			return;
		}

		if ( $el.hasClass( 'input--select' ) ) {
			return;
		}

		var $select = $el.wrap( '<span class="input input--select"></span>' );

		$select
			.parent( 'span' )
			.append( '<svg class="icon--arrow-down"><use xlink:href="' + Astoundify.assetUri + '/images/sprite.svg#icon-arrow-down"></use></svg>' );
	};

	/**
	 * Destroy a select.
	 *
	 * @since 1.0.0
	 *
	 * @param string element
	 */
	self.destroy = function( element ) {
		var $el = $(element);

		$el.parent( 'span' ).removeClass( 'input input--select' );
		$el.children( 'icon--arrow-down' ).remove();
	};

	/**
	 * Bind to the DOM
	 *
	 * @since 1.0.0
	 */
	$(document).ready(function() {
		self.wrap();

		$( '.select2' ).select2({
			minimumResultsForSearch: 20
		});
	});

})( jQuery );
